import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { isLoggedIn } from '../../utils/security'
import config from '../../config/config'
import { LOGIN_PATH } from '../../config/routes'
import PoiComment from './PoiComment'
import PoiCommentForm from './PoiCommentForm'
import { useAuth } from '../../contexts/AuthContext'
import { setFlashMessage } from '../../contexts/WebsiteContext'

const PoiComments = ({ poi }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { authToken } = useAuth()

  const [comments, setComments] = useState([])
  const [showForm, setShowForm] = useState(false)

  const handleAddComment = () => {
    if (!isLoggedIn()) {
      navigate(LOGIN_PATH)
    } else {
      setShowForm(true) // Afficher le formulaire lors du clic sur le bouton
    }
  }

  const fetchComments = async () => {
    try {
      const response = await axios.get(
        `${config.apiUrl}poi-comment?poi=${poi.id}&status=VALIDATED`,
      )
      setComments(response.data)
    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    }
  }

  useEffect(() => {
    fetchComments()
  }, [poi.id])

  const handleCommentAdded = () => {
    setShowForm(false)
  }

  return (
    <div>
      <hr />
      <h2>{t('COMMENTS')}</h2>
      <button
        className="btn btn-primary expand-button"
        onClick={handleAddComment}
      >
        {t('ADD_COMMENT')}
      </button>

      {/* Afficher le formulaire uniquement si showForm est vrai */}
      {showForm && (
        <PoiCommentForm
          poi={poi}
          authToken={authToken}
          onCommentAdded={handleCommentAdded}
        />
      )}

      <div className="comments-list">
        {comments && comments.length > 0 ? (
          comments.map((comment, index) => (
            <div key={index}>
              <PoiComment comment={comment} />
            </div>
          ))
        ) : (
          <p style={{ margin: '1rem' }}>{t('NO_COMMENT_MESSAGE')}</p>
        )}
      </div>
    </div>
  )
}

export default PoiComments
